export default __webpack_public_path__ + "static/media/JCB-Color.2557d20d.svg";